import { IFalsificatViewDTO } from "../../coreapi-dto/dirs/Falsificat";
import {  IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";

class FalsificatRequest extends BaseDirRequest<IFalsificatViewDTO, IFalsificatViewDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "Falsificat", token, eventHandler)
    }
}

export default FalsificatRequest